/**
 * Event Bar Renderer
 * 
 * Unified rendering for event bars (4px height colored bars) used in calendars.
 */

import { getEventBarColor } from './priority-colors.js';
import type { Priority } from './priority-colors.js';
import { designTokens } from './design-system.js';

export interface EventBarConfig {
  title: string;
  priority?: Priority;
  color?: string;
  onClick?: () => void;
  id?: string;
}

/**
 * Render a single event bar
 */
export function renderEventBar(config: EventBarConfig): string {
  const color = config.color || getEventBarColor(config.priority);
  const clickHandler = config.onClick 
    ? `onclick="window.__eventBarClick && window.__eventBarClick('${escapeHtml(config.id || '')}');"`
    : '';
  
  return `
    <div 
      class="event-bar" 
      data-event-id="${config.id || ''}"
      style="
        height: ${designTokens.spacing.eventBarHeight};
        background: ${color};
        border-radius: 2px;
        cursor: ${config.onClick ? 'pointer' : 'default'};
        transition: opacity 0.2s;
        margin-bottom: 2px;
      "
      title="${escapeHtml(config.title)}"
      ${clickHandler}
      onmouseover="this.style.opacity='0.8';"
      onmouseout="this.style.opacity='1';"
    ></div>
  `;
}

/**
 * Render multiple event bars
 */
export function renderEventBars(events: EventBarConfig[]): string {
  return events.map(event => renderEventBar(event)).join('');
}

/**
 * Escape HTML to prevent XSS
 */
function escapeHtml(text: string): string {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}

